export default {
    projectId: 452, // 必传 ，在58北斗监控平台添加项目时，生成的项目ID
    isProd: true, //  非必传， 是否将捕获的异常信息发送到北斗服务器   为true时 发送上报请求 默认为true
    isDebug: false // 非必传  是否打印日志 为true时 打印 默认为false
};
